import { Activity } from '@/types/activities'
import { Question } from '@/types/questions'

export const createFormKeyFromActivityAndQuestion = (activity: Activity, question: Question, index?: number) => {
    let formKey = `AC${activity.id}_${question.id}`
    if (index) {
        formKey += `_${index}`
    }
    return formKey
}

export const createEndpointKeyFromFormKeyAndAnswerId = (formKey: string, answerId: string): string => {
    return `EK${formKey}_${answerId}`
}
